import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

class AuthPersistence {
    constructor() {
        this.authCookieKey = 'milestones-auth';
        this.expires = 3; // days
    }

    config(config) {
        if (config.authCookieKey) {
            this.authCookieKey = config.authCookieKey;
        }

        if (config.expires) {
            this.expires = config.expires;
        }
    }

    createInstance(modules) {
        return new VuexPersistence({
            restoreState: (key) => {
                return Cookies.getJSON(this.authCookieKey);
            },
            saveState: (key, state) => {
                return Cookies.set(this.authCookieKey, state, {
                    expires: this.expires,
                    domain: window.env.MILESTONES_DOMAIN
                });
            },
            reducer: (state) => ({
                auth: {
                    isUserAuthenticated: state.auth.isUserAuthenticated,
                    auth: state.auth.auth,
                    isRefreshingToken: state.auth.isRefreshingToken,
                    lastAuthTimestamp: state.auth.lastAuthTimestamp,
                }
            }),
            modules: modules
        });
    }

    removeAuthCookies() {
        Cookies.remove(this.authCookieKey, {domain: window.env.MILESTONES_DOMAIN});
    }
}

export default new AuthPersistence();
